class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name'),
      event.target.dataset.quantityVariantId
    );
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  // updateQuantity(line, quantity, name, variantId) {
  //   this.enableLoading(line);

  //   const body = JSON.stringify({
  //     line,
  //     quantity,
  //     sections: this.getSectionsToRender().map((section) => section.section),
  //     sections_url: window.location.pathname,
  //   });

  //   console.log("update body here", body)

  //   fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
  //     .then((response) => {
  //       return response.text();
  //     })
  //     .then((state) => {
  //       const parsedState = JSON.parse(state);
  //       console.log("parsedState", parsedState)

  //       const quantityElement =
  //         document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
  //       const items = document.querySelectorAll('.cart-item');

  //       if (parsedState.errors) {
  //         quantityElement.value = quantityElement.getAttribute('value');
  //         this.updateLiveRegions(line, parsedState.errors);
  //         return;
  //       }

  //       this.classList.toggle('is-empty', parsedState.item_count === 0);
  //       const cartDrawerWrapper = document.querySelector('cart-drawer');
  //       const cartFooter = document.getElementById('main-cart-footer');

  //       if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
  //       if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

  //       this.getSectionsToRender().forEach((section) => {
          
  //         const elementToReplace =
  //           document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
  //         elementToReplace.innerHTML = this.getSectionInnerHTML(
  //           parsedState.sections[section.section],
  //           section.selector
  //         );
  //       });
  //       const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
  //       let message = '';
  //       if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
  //         if (typeof updatedValue === 'undefined') {
  //           message = window.cartStrings.error;
  //         } else {
  //           message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
  //         }
  //       }
  //       this.updateLiveRegions(line, message);

  //       const lineItem =
  //         document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
  //       if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
  //         cartDrawerWrapper
  //           ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
  //           : lineItem.querySelector(`[name="${name}"]`).focus();
  //       } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
  //         trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
  //       } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
  //         trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
  //       }

  //       publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
  //     })
  //     .catch(() => {
  //       this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
  //       const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
  //       errors.textContent = window.cartStrings.error;
  //     })
  //     .finally(() => {
  //       this.disableLoading(line);
  //     });

  //     const cartUpdatedEvent = new CustomEvent('cartUpdated', {
  //       detail: {
  //         message: 'Cart was updated',
  //       }
  //     });
  //     document.dispatchEvent(cartUpdatedEvent);
      
  // }
  
  async updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const sectionsToRender = this.getSectionsToRender();
    const sectionKeys = sectionsToRender.map(s => s.section);

    const safeMountReplace = (sectionsHtml) => {
      sectionsToRender.forEach((section) => {
        const container = document.getElementById(section.id);
        if (!container) return;
        const mount = section.selector ? (container.querySelector(section.selector) || container) : container;
        const html = sectionsHtml?.[section.section];
        if (!html) return;
        // getSectionInnerHTML must return a string
        mount.innerHTML = this.getSectionInnerHTML(html, section.selector);
      });
    };

    try {
      // 1) Change the requested line first
      const changeBody = JSON.stringify({
        line,
        quantity,
        sections: sectionKeys,
        sections_url: window.location.pathname
      });

      const changeRes = await fetch(routes.cart_change_url, {
        ...fetchConfig(),
        body: changeBody,
        cache: 'no-store'
      });
      const changeText = await changeRes.text();
      const firstState = JSON.parse(changeText); // includes sections for the FIRST change

      const qtyEl =
        document.getElementById(`Quantity-${line}`) ||
        document.getElementById(`Drawer-quantity-${line}`);

      if (firstState.errors) {
        if (qtyEl) qtyEl.value = qtyEl.getAttribute('value');
        this.updateLiveRegions(line, firstState.errors);
        return;
      }

      // 2) Decide gift op using the FIRST state (after Shopify applied the user's change)
      const GIFT_VARIANT_ID = 46264009818289;
      const isGiftLine = String(variantId) === String(GIFT_VARIANT_ID);

      const isGift = (i) => i.properties && i.properties._gift === 'true';
      const items = firstState.items || [];
      const giftLine = items.find(i => i.variant_id === GIFT_VARIANT_ID && isGift(i));

      // total parents (all non-gifts). If you want only Men/Women, filter by handle/tag.
      const parents = items.filter(i => !isGift(i));
      const parentsQty = parents.reduce((n, i) => n + (i.quantity || 0), 0);

      // Previous qty of the changed input (from DOM), and updated qty after change
      const prevInputQty = parseInt(
        (document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`))?.getAttribute('value') || '0',
        10
      );
      const afterInputQty = items[line - 1]?.quantity ?? 0;
      const lineDelta = afterInputQty - prevInputQty;

      // We will render from this final response (defaults to the first response)
      let finalSectionsHtml = firstState.sections;
      let finalCart = null;

      /*
      Rules:
      1) When parents quantity increase, gift increases by the same quantity.
      2) When parents quantity decrease, gift qty cannot exceed parents qty (cap down if needed).
      3) When gift quantity decreases, do nothing extra (just render).
      4) When gift quantity increases, gift qty cannot exceed parents qty (cap down if needed).
      + If giftLine is null: only add a gift when parents increased; otherwise leave as-is.
      */

      if (!isGiftLine) {
        // The user changed a PARENT line.
        if (lineDelta > 0) {
          // (1) Parents increased: increase gift by same delta.
          if (giftLine) {
            const newGiftQty = giftLine.quantity + lineDelta;
            const res = await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Accept':'application/json', 'Content-Type':'application/json' },
              cache: 'no-store',
              body: JSON.stringify({
                id: giftLine.key,
                quantity: newGiftQty,
                sections: sectionKeys,
                sections_url: window.location.pathname
              })
            });
            const state = await res.json();
            finalSectionsHtml = state.sections;
            finalCart = await fetch('/cart.js', { cache: 'no-store' }).then(r => r.json());
          } else {
            if(quantity === 0){
              finalCart = await fetch('/cart.js', { cache: 'no-store' }).then(r => r.json());
            }else{
              // giftLine is null → add a gift with exactly the delta (allow parents to exist without gifts unless they increase)
              const res = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Accept':'application/json', 'Content-Type':'application/json' },
                cache: 'no-store',
                body: JSON.stringify({
                  items: [{
                    id: GIFT_VARIANT_ID,
                    quantity: lineDelta,
                    properties: { _gift: 'true' }
                  }],
                  sections: sectionKeys,
                  sections_url: window.location.pathname
                })
              });
              const state = await res.json();
              finalSectionsHtml = state.sections;
              finalCart = await fetch('/cart.js', { cache: 'no-store' }).then(r => r.json());
            }
          }
        } else if (lineDelta < 0) {
          // (2) Parents decreased: cap gift so it does not exceed parentsQty.
          if (giftLine && giftLine.quantity > parentsQty) {
            const res = await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Accept':'application/json', 'Content-Type':'application/json' },
              cache: 'no-store',
              body: JSON.stringify({
                id: giftLine.key,
                quantity: parentsQty,
                sections: sectionKeys,
                sections_url: window.location.pathname
              })
            });
            const state = await res.json();
            finalSectionsHtml = state.sections;
            finalCart = await fetch('/cart.js', { cache: 'no-store' }).then(r => r.json());
          } else {
            console.log("case no call 1")
            // giftLine null or already <= parents → no extra call
            finalCart = await fetch('/cart.js', { cache: 'no-store' }).then(r => r.json());
          }
        } else {
          if(quantity === 0) {
            const res = await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Accept':'application/json', 'Content-Type':'application/json' },
              cache: 'no-store',
              body: JSON.stringify({
                id: giftLine.key,
                quantity: 0,
                sections: sectionKeys,
                sections_url: window.location.pathname
              })
            });
            const state = await res.json();
            finalSectionsHtml = state.sections;
            finalCart = await fetch('/cart.js', { cache: 'no-store' }).then(r => r.json());            
          }else{
            // No parent delta → no extra call
            finalCart = await fetch('/cart.js', { cache: 'no-store' }).then(r => r.json());
          }
        }
      } else {
        // The user changed the GIFT line.
        const updatedGiftQty = afterInputQty; // aka giftLine?.quantity after user's change
        const giftDelta = updatedGiftQty - prevInputQty;

        if (giftDelta < 0) {
          // (3) Gift decreased: do nothing extra (no API calls). We'll render the existing firstState.
          finalCart = await fetch('/cart.js', { cache: 'no-store' }).then(r => r.json());
        } else if (giftDelta > 0 && updatedGiftQty > parentsQty) {
          // (4) Gift increased but cannot exceed parents → cap down to parentsQty.
          // If parentsQty is 0, this sets gift to 0 (removes it).
          const targetQty = parentsQty;
          const res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Accept':'application/json', 'Content-Type':'application/json' },
            cache: 'no-store',
            body: JSON.stringify({
              id: items[line - 1]?.key, // gift line key at this index
              quantity: targetQty,
              sections: sectionKeys,
              sections_url: window.location.pathname
            })
          });
          const state = await res.json();
          finalSectionsHtml = state.sections;
          finalCart = await fetch('/cart.js', { cache: 'no-store' }).then(r => r.json());
        } else {
          // Gift increased within cap OR unchanged → no extra call
          finalCart = await fetch('/cart.js', { cache: 'no-store' }).then(r => r.json());
        }
      }


      // 4) Render using the LATEST sections HTML (from gift op if it ran)
      safeMountReplace(finalSectionsHtml);

      // 5) Empty state / focus / events using fresh cart
      this.classList.toggle('is-empty', finalCart.item_count === 0);
      const cartDrawerWrapper = document.querySelector('cart-drawer');
      const cartFooter = document.getElementById('main-cart-footer');
      if (cartFooter) cartFooter.classList.toggle('is-empty', finalCart.item_count === 0);
      if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', finalCart.item_count === 0);

      const updatedValue = finalCart.items?.[line - 1]?.quantity;
      let message = '';
      
      // if (updatedValue !== undefined && qtyEl && updatedValue !== parseInt(qtyEl.value, 10)) {
      //   message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
      // }

      this.updateLiveRegions(line, message);

      const lineItem =
        document.getElementById(`CartItem-${line}`) ||
        document.getElementById(`CartDrawer-Item-${line}`);
      if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
        cartDrawerWrapper
          ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
          : lineItem.querySelector(`[name="${name}"]`).focus();
      } else if (finalCart.item_count === 0 && cartDrawerWrapper) {
        trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
      } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
        trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
      }

      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: finalCart, variantId });
      document.dispatchEvent(new CustomEvent('cartUpdated', { detail: { message: 'Cart was updated' } }));

    } catch (err) {
      console.error(err);
      this.querySelectorAll('.loading__spinner').forEach((ov) => ov.classList.add('hidden'));
      const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
      if (errors) errors.textContent = window.cartStrings.error;
    } finally {
      this.disableLoading(line);
    }
  }


  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
